var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShelves = function SvgShelves(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "shelves_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shelves_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.312 28.185a.9.9 0 0 1-.668-.27.9.9 0 0 1-.269-.667V2.765q0-.4.27-.668.27-.27.668-.27.399 0 .668.27.27.27.269.668v1.622h17.5V2.765q0-.4.27-.668.27-.27.668-.27.399 0 .668.27.27.27.269.668v24.483q0 .398-.27.668a.9.9 0 0 1-.668.27.9.9 0 0 1-.668-.27.9.9 0 0 1-.269-.668v-1.623H6.25v1.623q0 .398-.27.668a.9.9 0 0 1-.668.27M6.25 13.75h2.885v-3.726q0-.48.324-.805.325-.324.805-.324h4.472q.48 0 .805.324.324.325.324.805v3.726h7.885V6.262H6.25zm0 10h7.885v-3.726q0-.48.324-.805.325-.324.805-.324h4.472q.48 0 .805.324.324.325.324.805v3.726h2.885v-8.125H6.25z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShelves);
export default ForwardRef;